import React from "react";
import { Icon, Link } from "@/styles/components";
import { Body } from "@/styles/typography";
import { AnimatePresence, motion } from "framer-motion";
import S from "./PartnerProducts.styled";
import Checkbox from "@/styles/components/Checkbox";

interface ActiveFiltersProps {
  activeFilters: string[];
  removeFilter: (filter: string) => void;
}

export const ActiveFilters: React.FC<ActiveFiltersProps> = ({
  activeFilters,
  removeFilter,
}) => (
  <AnimatePresence>
    {activeFilters.map((filter, index) => (
      <S.Filter
        key={index}
        as={motion.div}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={() => removeFilter(filter)}
      >
        <S.Active>
          <Body>{filter}</Body>
          <Icon src="Close" width={6} margin="0 0 0 8px" />
        </S.Active>
      </S.Filter>
    ))}
  </AnimatePresence>
);

interface FilterDropdownProps {
  items: string[];
  activeItems: string[];
  toggleItem: (item: string) => void;
}

export const FilterDropdown: React.FC<FilterDropdownProps> = ({
  items,
  activeItems,
  toggleItem,
}) => {
  return (
    <>
      {items.map((item, index) => (
        <S.Label onClick={() => toggleItem(item)} key={index} htmlFor={item}>
          <Checkbox
            checked={activeItems.includes(item)}
            colorOptions="creme"
            onClick={() => toggleItem(item)}
          />
          <Body
            weight={activeItems.includes(item) ? 700 : 400}
            margin="4px 0"
            size={16}
          >
            {item}
          </Body>
        </S.Label>
      ))}
    </>
  );
};
